export default {
  template: '<div></div>',
  controller: 'TermsDialogController',
  bindings: {
      term: '<',
  }
}



// WEBPACK FOOTER //
// ./src/modules/terms-preview/components/terms-dialog/terms-dialog-component.js